export const GET_STUDY_LEVELS = "GET_STUDY_LEVELS"
export const GET_STUDY_LEVELS_FAIL = "GET_STUDY_LEVELS_FAIL"
export const GET_STUDY_LEVELS_SUCCESS = "GET_STUDY_LEVELS_SUCCESS"

export const ADD_NEW_STUDY_LEVEL = "ADD_NEW_STUDY_LEVEL"
export const ADD_STUDY_LEVEL_SUCCESS = "ADD_STUDY_LEVEL_SUCCESS"
export const ADD_STUDY_LEVEL_FAIL = "ADD_STUDY_LEVEL_FAIL"

export const UPDATE_STUDY_LEVEL = "UPDATE_STUDY_LEVEL"
export const UPDATE_STUDY_LEVEL_SUCCESS = "UPDATE_STUDY_LEVEL_SUCCESS"
export const UPDATE_STUDY_LEVEL_FAIL = "UPDATE_STUDY_LEVEL_FAIL"

export const DELETE_STUDY_LEVEL = "DELETE_STUDY_LEVEL"
export const DELETE_STUDY_LEVEL_SUCCESS = "DELETE_STUDY_LEVEL_SUCCESS"
export const DELETE_STUDY_LEVEL_FAIL = "DELETE_STUDY_LEVEL_FAIL"





